<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.9987 8C20.9987 9.32608 20.4719 10.5979 19.5342 11.5355C18.5965 12.4732 17.3247 13 15.9987 13C14.6726 13 13.4008 12.4732 12.4631 11.5355C11.5255 10.5979 10.9987 9.32608 10.9987 8C10.9987 6.67392 11.5255 5.40215 12.4631 4.46447C13.4008 3.52678 14.6726 3 15.9987 3C17.3247 3 18.5965 3.52678 19.5342 4.46447C20.4719 5.40215 20.9987 6.67392 20.9987 8ZM6 26.824C6.04285 24.2005 7.11512 21.6989 8.98557 19.8587C10.856 18.0186 13.3748 16.9873 15.9987 16.9873C18.6225 16.9873 21.1413 18.0186 23.0118 19.8587C24.8822 21.6989 25.9545 24.2005 25.9973 26.824C22.8605 28.2624 19.4495 29.0047 15.9987 29C12.4307 29 9.044 28.2213 6 26.824Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number;
    color?: string;
  }>(),
  {
    size: 32,
    color: "#D0A444",
  },
);
</script>
